module.exports = __webpack_public_path__ + "img/syukyaku-top-pa003.76409ed9.png";